import {
  IProduct,
  ProductData,
  Products,
  productApi,
  productDataTransformer,
} from '@commerce-product-webcomponents/sdk';
import { aprApi, AprProps } from '@commerce-webcomponents/sdk';

interface GetProducts extends AprProps {
  products: { productId: string; isBundle: boolean }[];
  fulfillmentType?: string;
  warehouseId?: string;
}

const getProductIds = async ({ products, aprContainerKey, pageName, filter, channel, slots }: GetProducts) => {
  // This needs to be updated based on APR api response structure
  // Currently bundle is only supported by cms provided product ids
  const productIds = products.filter((p) => p.isBundle).map((p) => p.productId);
  let ids: string[] = [];
  let isApr = false;
  if (aprContainerKey && pageName) {
    try {
      const productIdsByAPR = await aprApi.getProductIdsByAPR({
        aprContainerKey,
        pageName,
        ...(filter && { filter }),
        ...(channel && { channel }),
        ...(slots && { slots }),
      });
      isApr = true;
      if (productIdsByAPR.length > 0) {
        ids = [...productIdsByAPR];
      }
    } catch {
      ids = [...productIds];
    }
  } else {
    ids = [...productIds];
  }

  return { ids, isApr };
};

export const getProductsData = async ({
  products = [],
  aprContainerKey,
  pageName,
  fulfillmentType,
  warehouseId,
  channel,
  filter,
  slots,
}: GetProducts) => {
  const productItems = products.map((p) => p.productId);
  let nonBundleItems: string[];
  if (aprContainerKey && pageName) {
    nonBundleItems = [];
  } else {
    nonBundleItems = products.filter((p) => !p.isBundle).map((p) => p.productId);
  }
  const productIds = await getProductIds({
    products,
    aprContainerKey,
    pageName,
    channel,
    filter,
    slots,
  });
  const { isApr } = productIds;
  let { ids: idList } = productIds;
  let itemNumberList = [...nonBundleItems];
  if (itemNumberList.length && idList.length) {
    itemNumberList = [...Array(idList.length).fill(''), ...nonBundleItems];
    idList = [...idList, ...Array(nonBundleItems.length).fill('')];
  }
  const productsList: Products = await productApi.getProductByIds({
    itemNumberList,
    idList,
    projections: 'DETAILED',
    fulfillmentType,
    warehouseId,
  });
  const productsData: IProduct[] | undefined = productsList?.products?.map((product: ProductData) =>
    productDataTransformer(product),
  );
  productsData?.sort((prev, next) => productItems.indexOf(prev.productId) - productItems.indexOf(next.productId));
  return { products: productsData ?? [], isApr };
};
